import type {
  ICompanyMSServiceDocument,
  ICompanyMSServiceUploadDocument,
} from './../types/document/models'
import { makeDocumentService } from '~/cynqueModules/factoriesForServices/documents'

export const {
  createDocument: createCompanyMSServiceDocument,
  updateDocument: updateCompanyMSServiceDocument,
  deleteDocument: deleteCompanyMSServiceDocument,
} = makeDocumentService<
  ICompanyMSServiceDocument,
  ICompanyMSServiceUploadDocument
>('/api/companymsservicedocuments', 'companyMSServiceDocument')
